import projectImg11 from '../assets/Images/sastaolx1.png'
import projectImg12 from '../assets/Images/sastaolx2.png'
import projectImg13 from '../assets/Images/sastaolx3.png'

import projectImg21 from '../assets/Images/quick1.png'
import projectImg22 from '../assets/Images/quick2.png'
import projectImg23 from '../assets/Images/quick3.png'

import projectImg31 from '../assets/Images/alien1.png'
import projectImg32 from '../assets/Images/alien2.png'
import projectImg33 from '../assets/Images/alien3.png'
import projectImg34 from '../assets/Images/alien4.png'
import projectImg35 from '../assets/Images/alien5.png'
import projectImg36 from '../assets/Images/alien6.png'

import projectImg41 from '../assets/Images/donatefood1.png'
import projectImg42 from '../assets/Images/donatefood2.png'
import projectImg43 from '../assets/Images/donatefood3.png'
import projectImg44 from '../assets/Images/donatefood4.png'
import projectImg45 from '../assets/Images/donatefood5.png'
import projectImg46 from '../assets/Images/donatefood6.png'
import projectImg47 from '../assets/Images/donatefood7.png'
import projectImg48 from '../assets/Images/donatefood8.png'
import projectImg49 from '../assets/Images/donatefood9.png'


export const webProjectsData = [
    {
        id: 1,
        imageUrl: projectImg41,
        title: '(ongoing) Donate Food - Connecting Communities, Reducing Waste',
        description:
            'Connecting Communities, Reducing Food Waste, Nourishing Lives.',
            detailDescription: `
            Welcome to [Your Platform Name], where we're passionate about building a more sustainable and equitable food system, right here in our community.  We connect businesses with surplus food to local charities who serve those in need, reducing waste and fighting hunger at the same time.
        
            <ul>
              <li>
                <strong>Our Mission:</strong> Connecting Communities, Reducing Food Waste, Nourishing Lives. This mission guides everything we do. We strive to create a positive impact on both people and the planet.
              </li>
              <li>
                <strong>The Alarming Truth About Food Waste:</strong> Globally, an estimated one-third of all food produced is lost or wasted. In [Your City/Region], this translates to approximately [Number] tons of food ending up in landfills each year. This wasted food contributes significantly to greenhouse gas emissions, consumes precious resources like water and land, and exacerbates the issue of food insecurity.
              </li>
              <li>
                <strong>Our Impact (So Far):</strong>
                 We're proud to report that we've facilitated the donation of [Number] meals to local charities, diverting [Number] tons of food waste from landfills. We've also partnered with [Number] businesses who have committed to reducing their food waste. See the positive change you can bring to your community when you join us!
              </li>
            </ul>
            <p>
              <strong>Our Inspiration:</strong> We are inspired by the simple belief that good food shouldn't go to waste while people in our community face hunger. We're building a platform to make it easier than ever for businesses and charities to connect and create a positive impact.
            </p>
            <p>
              <strong>Explore the possibilities with us:</strong> Join our growing network of local heroes! Every action you take with us helps ensure that your community flourishes.
            </p>
        
            What makes [Your Platform Name] special is our dedication to simplicity, transparency, and community. We focus on making the donation process effortless and impactful for everyone involved. Our responsive design ensures a seamless experience on any device, so you can help us reduce food waste no matter where you are.
          `,
        techStack: ['Ongoing Project','React', 'integrating with backend ...' ],
        githubLink: 'https://github.com/theprashantkumardas/Donate-Food',
        liveLink: '#',
        images: [
            projectImg41,
            projectImg42,
            projectImg43,
            projectImg44,
            projectImg45,
            projectImg46,
            projectImg47,
            projectImg48,
            projectImg49,
        ],
        category: 'web'
    },
    {
        id: 2,
        imageUrl: projectImg11,
        title: 'OLX-Type Marketplace with Chat, Payment, and More',
        description:
            'I developed a fully functional OLX-style marketplace website, enhanced with modern features.',
        detailDescription:
            `I developed a fully functional OLX-style marketplace website, enhanced with modern features to address real-world buying and selling challenges. Users can buy and sell second-hand or branded products while enjoying the following features:
            <ul>
                <li><strong>User Roles:</strong> Users can register as either buyers or sellers, or they can switch roles based on their needs.</li>
                <li><strong>Product Listings:</strong> Sellers can list their products with details like images, descriptions, and prices.</li>
                <li><strong>Chat Functionality:</strong> Integrated real-time chat enables direct communication between buyers and sellers, improving user interaction.</li>
                <li><strong>Cart System:</strong> Buyers can add products to their cart and proceed with a streamlined checkout process.</li>
                <li><strong>Payment Integration:</strong> Razorpay integration ensures secure and seamless online transactions.</li>
                <li><strong>Branded Collections:</strong> Specially curated collections of second-hand branded products make high-quality items accessible at affordable prices.</li>
                <li><strong>User-Friendly Interface:</strong> Built with modern UI principles using React and Tailwind CSS, the platform offers a seamless experience across devices.</li>
            </ul>
            This project is special because it combines the simplicity of buying and selling with enhanced features like chat and secure payment, making it an all-in-one solution for users.`,
        techStack: ['React', 'Node.js', 'Express', 'Razor pay', 'cloudinary'],
        githubLink: 'https://github.com/theprashantkumardas/_SastaOlx',
        liveLink: 'https://sastaolx-frontend.onrender.com/',
        images: [
            projectImg11,
            projectImg12,
            projectImg13,
        ],
        category: 'web'
    },
    {
        id: 3,
        imageUrl: projectImg21,
        title: 'Responsive Professional Website',
        description:
            'I designed and developed a responsive, modern website built with pure HTML, CSS, and JavaScript. ',
        detailDescription:
            `I designed and developed a responsive, modern website built with HTML, CSS, and JavaScript. The website is sleek, clean, and user-friendly, offering an engaging user experience across all devices. The design focuses on simplicity and usability, with a mobile-first approach ensuring smooth performance on smartphones, tablets, and desktops.
           <ul>
               <li>The website layout is designed to be visually appealing while maintaining functional ease.</li>
               <li>It incorporates interactive elements, including smooth transitions and animations using JavaScript, to keep the user experience dynamic and fluid.</li>
               <li>I paid special attention to making sure the site is SEO-friendly and accessible, ensuring a wide reach and better performance.</li>
           </ul>
           What makes this project special is the clean and minimalistic design, focusing on high usability without overwhelming the user. The responsive nature of the website ensures it looks and works perfectly on any screen size, providing a seamless experience.`,
        techStack: ['Html', 'CSS', 'Javascript'],
        githubLink: 'https://github.com/theprashantkumardas/Quick-Quill-',
        liveLink: 'https://lovely-jelly-88f8fa.netlify.app/',
        images: [
            projectImg21,
            projectImg22,
            projectImg23,
        ],
        category: 'web'
    },
    {
        id: 4,
        imageUrl: projectImg31,
        title: 'Alien Invasion',
        description:
            'Created a sci-fi theme website where the content is about destination for all things related to science, technology, space, and extraterriesterial life.',
        detailDescription:
            `Welcome to Alien Invasion Science, your ultimate destination for all things related to science, technology, space, and extraterrestrial life.
            <ul>
                <li><strong>INFO & ARTICLES:</strong> Information and articles on the latest scientific discoveries and theories related to alien technology, space, science and technology and the universe.</li>
                <li><strong>EXPLORATION:</strong> In-depth guides and tutorials on various subjects, such as the search for extraterrestrial intelligence, space travel and propulsion, and the impact of science and technology on society.</li>
                <li><strong>INFOGRAPHICS:</strong> A library of resources such as videos, infographics, and images that help to break up the text and make the information more accessible and engaging.</li>
            </ul>
                <p><strong>OUR GLOBAL SOURCES:</strong> Nasa, Isro, Space-X, Virgin Galactic. Blue Origin, LLC. Bigelow Aerospace, Inc. The X Prize Foundation. The Ultrawealthy. Sierra Nevada Corp. Space Systems. Orbital Sciences Corp. and many more</p>
                <p><strong>Explore The Informations Any where From The world</strong></p>
                What makes this project special is the clean and minimalistic design, focusing on high usability without overwhelming the user. The responsive nature of the website ensures it looks and works perfectly on any screen size, providing a seamless experience.`,
        techStack: ['Html', 'CSS', 'Javascript'],
        githubLink: 'https://github.com/theprashantkumardas/Alieninvasion',
        liveLink: 'https://dotalieninvasion.netlify.app/',
        images: [
            projectImg31,
            projectImg32,
            projectImg33,
            projectImg34,
            projectImg35,
            projectImg36,
        ],
        category: 'web'
    },
    
];
